<template>
  <div class="otp-input-box">
    <div class="otp-input-container">
      <input ref="input" type="text" :maxlength="length" :value="displayValue" @input="handleInput" @keydown="handleKeyDown" @paste="handlePaste" class="otp-input" inputmode="numeric" pattern="[0-9]*" />
      <div class="otp-display" v-click-away="onClickOutside" @click="handleContainerClick">
        <div v-for="(digit, index) in displayDigits" :key="index" class="otp-digit" :class="{ 'focused': currentFocusIndex === index }">
          {{ digit }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: String, // 綁定外部的驗證碼
    length: {
      type: Number,
      default: 6, // 預設 6 位驗證碼
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    submit: {
      type: Function,
      default: () => { },
    },
  },
  computed: {
    displayDigits() {
      const digits = this.displayValue.split('');
      return Array(this.length).fill('').map((_, i) => digits[i] || '');
    },
  },
  data() {
    return {
      displayValue: '',
      currentFocusIndex: 0,
    };
  },
  mounted() {
    this.$refs.input.focus();
  },
  methods: {
    handleInput(event) {
      const value = event.target.value.replace(/\D/g, '');
      this.displayValue = value;
      this.currentFocusIndex = event.target.selectionStart;
      this.$emit('input', value);
    },
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        this.$emit('enter', this.displayValue);
      } else if (event.key === 'ArrowLeft') {
        this.currentFocusIndex = Math.max(0, this.currentFocusIndex - 1);
      } else if (event.key === 'ArrowRight') {
        this.currentFocusIndex = Math.min(this.displayValue.length, this.currentFocusIndex + 1);
      }
    },
    handlePaste(event) {
      event.preventDefault();
      const pasteData = event.clipboardData.getData('text').replace(/\D/g, '');
      this.displayValue = pasteData.slice(0, this.length);
      this.$emit('input', this.displayValue);
    },
    handleContainerClick() {
      const lastIndex = this.displayValue.length;
      this.currentFocusIndex = lastIndex;
      this.$refs.input.focus();
      this.$refs.input.setSelectionRange(lastIndex, lastIndex);
    },
    onClickOutside() {
      this.$refs.input.blur();
      this.currentFocusIndex = -1;
    }
  },
  watch: {
    displayValue: {
      handler(newVal) {
        if (newVal.length === this.length) {
          this.submit();
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.otp-input-box {
  display: flex;
  justify-content: center;
  margin-top: 2.5rem;

  @media (max-height: 460px) {
    margin-top: 2rem;
  }

  @media (max-height: 450px) {
    margin-top: 1rem;
  }
}

.otp-input-container {
  position: relative;
  width: fit-content;
}

.otp-input {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: -1;
}

.otp-display {
  display: flex;
}

.otp-digit {
  width: 2rem;
  height: 2rem;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 600;
  color: $main;
  background: white;
  transition: border-color 0.3s;

  + .otp-digit {
    margin-left: 0.5rem;
  }

  &.focused {
    border-color: $main;
  }

  @media (max-width: 320px) {
    width: 1.5rem;
    height: 1.5rem;
    font-size: 1rem;
  }
}
</style>
